import { api } from '../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../query-client';
import { AxiosError } from 'axios';

export type DeleteClientQueryRequest = {
    id: string;
};

async function deleteClientQuery(request: DeleteClientQueryRequest, workpaperId: string): Promise<void> {
    const { data } = await api.delete(`/workpapers/${workpaperId}/client-queries/${request.id}`);
    return data;
}

export function useDeleteClientQuery(workpaperId: string): UseMutationResult<void, AxiosError, DeleteClientQueryRequest, unknown> {
    return useMutation((req) => deleteClientQuery(req, workpaperId), {
        onSettled: () => {
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries(['other-schedules']);
            queryClient.invalidateQueries(['workpapers', workpaperId, 'client-queries']);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
        },
    });
}
